import RasterTileSource from '../source/raster_tile_source';
import browser from '../util/browser';
import Texture from '../render/texture';
import {cacheEntryPossiblyAdded} from '../util/tile_request_cache';

class MBTilesRasterSource extends RasterTileSource {
    constructor(id, options, dispatcher, eventedParent) {
        super(id, options, dispatcher, eventedParent);
        this.type = "mbtiles_raster";
        this.db = this.openDatabase(options.path,options.name);
    }

    openDatabase(dbPath,name) {
        if ('sqlitePlugin' in self) {
            return this.copyDatabaseFile(dbPath,name).then(function () {
                return sqlitePlugin.openDatabase({name: name, location: 'default'});
            });
        } else {
            return Promise.reject(new Error("cordova-sqlite-evcore-extbuild-free plugin not available. " +
                "Please install the plugin and make sure this code is run after onDeviceReady event"));
        }
    }

    copyDatabaseFile(dbPath,dbName) {
        const sourceFileName = cordova.file.externalRootDirectory + dbPath;   
        // const sourceFileName = cordova.file.applicationDirectory + 'www/data/' + dbName;

        if(!('device' in self)) {
            return Promise.reject(new Error("cordova-plugin-device not available. " +
                "Please install the plugin and make sure this code is run after onDeviceReady event"));
        }

        return Promise.all([
            new Promise(function (resolve, reject) {
                resolveLocalFileSystemURL(sourceFileName, resolve, reject);
            }),
            new Promise(function (resolve, reject) {
                if(device.platform === 'Android') {
                    resolveLocalFileSystemURL(cordova.file.applicationStorageDirectory, function (dir) {
                        dir.getDirectory('databases', {create: true}, function (subdir) {
                            resolve(subdir);
                        });
                    }, reject);
                } 
                else {
                    reject("Platform not supported");
                }
            })
        ]).then(function (files) {
            const sourceFile = files[0];
            const targetDir = files[1];
            return new Promise(function (resolve, reject) {
                targetDir.getFile(dbName, {}, resolve, reject);
            }).catch(function () {
                console.log("Copying database to application storage directory");
                return new Promise(function (resolve, reject) {
                    sourceFile.copyTo(targetDir, dbName, resolve, reject);
                }).then(function () {
                    console.log("Database copied");
                });
            });
        });
    }

    readTile(z, x, y, callback) {
        const query = 'SELECT tile_data FROM tiles WHERE zoom_level=? AND tile_column=? AND tile_row=?';
        const params = [z, x, y];
        this.db.then(function(db) {
            db.transaction(function (txn) {
                txn.executeSql(query, params, function (tx, res) {
                    let img = res.rows.length ? res.rows.item(0).tile_data : undefined;
                    // img = atob(img)
                    if(img){
                        let arrayImg = convertBase64ToUint8Array(img);
                        const blob = new Blob([arrayImg], {type: 'image/jpg'});    //这一步有问题
                        let bitMapImg = window.createImageBitmap(blob)    //导致img没有数据
                        callback(undefined, bitMapImg); // Tile contents read, callback success.
                    }
                    
                });
            }, function (error) {
                callback(error); // Error executing SQL
            });
        }).catch(function(err) {
            callback(err);
        });

        function convertBase64ToUint8Array(base64) {
            var raw = self.atob(base64);
            var rawLength = raw.length;
            var array = new Uint8Array(new ArrayBuffer(rawLength));

            for (var i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        };
    }

    loadTile(tile, callback) {
        const z = Math.min(tile.tileID.canonical.z, this.maxzoom || tile.tileID.canonical.z); // Don't try to get data over maxzoom
        const x = tile.tileID.canonical.x;
        const y = Math.pow(2,z)-tile.tileID.canonical.y-1; // Tiles on database are tms (inverted y axis)

        this.readTile(z, x, y, dispatch.bind(this));
        
        function dispatch(err, img) {
            if (tile.aborted) {
                tile.state = 'unloaded';
                callback(null);
            } else if (err) {
                tile.state = 'errored';
                callback(err);
            } else if (img) {
                if (this.map._refreshExpiredTiles) tile.setExpiryData(img);
                // delete (img: any).cacheControl;
                // delete (img: any).expires;
                img.then((value) => {
                    // console.log(value)
                    const context = this.map.painter.context;
                    const gl = context.gl;
                    tile.texture = this.map.painter.getTileTexture(value.width);
                    if (tile.texture) {
                        tile.texture.update(value, {useMipmap: true});
                    } else {
                        tile.texture = new Texture(context, value, gl.RGBA, {useMipmap: true});
                        tile.texture.bind(gl.LINEAR, gl.CLAMP_TO_EDGE, gl.LINEAR_MIPMAP_NEAREST);
                        if (context.extTextureFilterAnisotropic) {
                            gl.texParameterf(gl.TEXTURE_2D, context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, context.extTextureFilterAnisotropicMax);
                        }
                    }

                    tile.state = 'loaded';

                    cacheEntryPossiblyAdded(this.dispatcher);

                    callback(null);
                })
            }
        }
    }
}

export default MBTilesRasterSource;
